import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";
import { fmtMoney, fmtNumber } from "@/lib/simulator";

/**
 * Revenue vs Team Size — X: cumulative team members, Y: cumulative commissions.
 * No time dimension. Each point is a checkpoint as your tree fills in
 * (level 1 → level 20 depth).
 */
export default function GrowthChart({ curve }) {
  const data = curve.map((p) => ({
    members: Math.round(p.members),
    cash: Math.round(p.cash),
    rank: p.rank,
  }));

  return (
    <div className="h-[280px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 16, left: 4, bottom: 4 }}>
          <defs>
            <linearGradient id="growth-area" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EC4899" stopOpacity={0.55} />
              <stop offset="100%" stopColor="#A855F7" stopOpacity={0.05} />
            </linearGradient>
            <linearGradient id="growth-line" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#F97316" />
              <stop offset="50%" stopColor="#EC4899" />
              <stop offset="100%" stopColor="#A855F7" />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#ffffff10" vertical={false} />
          <XAxis
            dataKey="members"
            type="number"
            domain={[0, "dataMax"]}
            stroke="#64748B"
            tickLine={false}
            axisLine={false}
            fontSize={11}
            fontFamily="JetBrains Mono, monospace"
            tickFormatter={(v) =>
              v >= 1000 ? `${(v / 1000).toFixed(1)}k` : `${v}`
            }
            label={{
              value: "team members",
              position: "insideBottom",
              offset: -2,
              fill: "#475569",
              fontSize: 10,
              fontFamily: "JetBrains Mono, monospace",
            }}
          />
          <YAxis
            stroke="#64748B"
            tickLine={false}
            axisLine={false}
            fontSize={11}
            fontFamily="JetBrains Mono, monospace"
            tickFormatter={(v) =>
              v >= 1000 ? `$${(v / 1000).toFixed(1)}k` : `$${v}`
            }
            width={60}
          />
          <Tooltip
            cursor={{
              stroke: "rgba(236,72,153,0.4)",
              strokeWidth: 1,
              strokeDasharray: "3 3",
            }}
            contentStyle={{
              background: "rgba(15,23,34,0.94)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 10,
              color: "#F8FAFC",
              backdropFilter: "blur(10px)",
              fontSize: 12,
              padding: "10px 12px",
            }}
            labelStyle={{ color: "#94A3B8", marginBottom: 4 }}
            formatter={(v, _n, item) => [
              fmtMoney(v),
              `${item.payload.rank} · you earn`,
            ]}
            labelFormatter={(m) => `${fmtNumber(m)} team members`}
          />
          <Area
            type="monotone"
            dataKey="cash"
            stroke="url(#growth-line)"
            strokeWidth={2.5}
            fill="url(#growth-area)"
            activeDot={{ r: 5, fill: "#EC4899", stroke: "#fff", strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
